import { useState, useEffect } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import SearchIcon from "../../assets/images/icons/search-icon.webp";
// import { auraGames } from "../../lib/data/auraGames.data";
// import { aviatorGames } from "../../lib/data/aviatorGames.data";
import { casinoPageData } from "../../lib/data/casinoTabs.data";
import { SlotGames } from "../../lib/data/SlotGames.data";
import { PragmaticPlayGames } from "../../lib/data/pragmaticplayGames.data";
// import { QtechGames } from "../../lib/data/QtechGames.data";
// import { EvolutionGames } from "../../lib/data";

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);

  const totalGames = {
    ...casinoPageData.ezugi,
    ...casinoPageData.evolution,
    ...casinoPageData.supernowa,
    ...casinoPageData.qtechbaccarat,
    ...casinoPageData.qtechlivegames,
    ...casinoPageData.prgamaticplayworldcasino,
    ...casinoPageData.kingmaker,
    ...SlotGames.spribetab,
    ...SlotGames.auragamingtab,
    ...SlotGames.PragmaticPlayGames,
    ...SlotGames.qtechpokertab,
    ...SlotGames.qtechfunwctab,
    ...SlotGames.qtechslotstab,
    ...SlotGames.qtechcrashtab,
    ...SlotGames.onlyplayslottab,
    ...SlotGames.ezuginetenttab,
    ...SlotGames.ezugiredtigertab,
    // ...SlotGames.vivoslotstab,
    ...PragmaticPlayGames,
  };

  useEffect(() => {
    return () => {
      setFilteredData(null);
    };
  }, []);

  const handleClose = () => {
    setFilteredData(null);
    setShow(false);
  };
  const handleSearch = (e) => {
    if (e) {
      let filteredValue = Object.values(totalGames)?.filter((item) => {
        return (
          item?.name && item.name.toLowerCase().indexOf(e?.toLowerCase()) > -1
        );
      });
      setFilteredData(filteredValue);
    } else {
      setFilteredData(null);
    }
  };

  return (
    <>
      <div className="search-box">
        <div className="searchGames" onClick={handleShow}>
          {/* <BiSearch /> */}
          <p>Search</p>
          <img src={SearchIcon} alt="search" />
        </div>
      </div>

      <Modal show={show} onHide={handleClose} className="search-modal">
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Search Games</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3 search-icon">
            <Form.Control
              placeholder="Search your favourite games here..."
              aria-label="Text input with dropdown button"
              type="search"
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
          </InputGroup>

          <ul className="gamelisting">
            {filteredData &&
              filteredData.map((item) => (
                <li>
                  <a href={item.href}>
                    <img src={item.imgUrl || item?.cover?.src} />
                    <div className="providerName">{item.providerName}</div>
                    <div className="GameName">{item.name}</div>
                  </a>
                </li>
              ))}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
